import React, { useEffect, useMemo } from 'react'
import { Panel, Container, Tool } from '@sencha/ext-modern'

import { getMixedProps, genNewList } from './blockPublic'
import { useDelayTimer, useEventHandler, useInstData } from 'tyan/public/hooks'
import { reconfigButton } from 'tyan/public/utility'
import { handleCommonContextMenu } from '../../column/contextmenu'

const toolDefault = { margin: '0', ui: 'action', padding: '0 5 0 0' }
const Border = ({ field: { _fieldsetName }, field, /* onChange,  */initValues, changedValues, defaultStyle, that, renderField }) => {
	const {
		props: {
			label, labelAlign, borderStyle, padding, layout: layoutProp, initHeight, buttons, delay,
			contextmenu, noLocale,
			...props
		},
		rest: { name, _border, items, forceDisabled, list: borderList, default: _default = {}, ...rest }
	} = getMixedProps('_border', [defaultStyle, field])

	const { me, me: { fieldID, height, state: { showMe } }, setState } = useInstData(
		undefined,
		useMemo(() => ({ fieldID: `border-${Tyan.getUuid()}`, height: initHeight, state: { showMe: false } }), [])
	)

	const handleContextMenu = useEventHandler(e => handleCommonContextMenu(contextmenu, e))
	const listeners = useMemo(() => ({
		contextmenu: {
			element: 'element',
			fn: handleContextMenu
		}
	}), [])

	const layout = typeof layoutProp === 'string' ? { type: layoutProp } : layoutProp
	rest.disabled = props.disabled
	delete rest.value

	const { doDelay } = useDelayTimer(10)

	useEffect(() => {
		const { dom } = me
		const doShowMe = () => {
			!me.state.showMe && setState({ showMe: true })
			// Tyan.unobserveIO(dom)
		}

		const doHideMe = () => {
			const { height } = dom.getBoundingClientRect()
			me.height = height
			me.state.showMe && setState({ showMe: false })
		}

		if (delay) {
			Tyan.observeIO(dom, ({ isIntersecting }) => {
				isIntersecting ? doDelay(doShowMe) : doDelay(doHideMe)
			})

			return () => {
				Tyan.unobserveIO(dom)
			}
		} else
			doDelay(doShowMe)
	}, [])

	// console.log('buttons:', buttons)
	// console.log('labelAlign:', labelAlign)
	return <Container id={`container-${fieldID}`} userCls='t-form-border'
		layout='fit' {...props} ref={ref => ref && (me.dom = ref.cmp.el.dom)} {...showMe ? {} : { height }}
		errorTarget={undefined}
	>
		{showMe
			? <>
				<Container {...labelAlign} layout='fit' /* maxWidth='calc(100% - 16px)' */>
					{
						<Container layout={{ type: 'hbox', align: 'center' }} listeners={listeners}>
							<Panel userCls='t-form-border-label' /* margin='7 0 0 0' */ padding='0 5 0 5 ' maxWidth='100%'>
								<div className='t-form-border-label-element' data-qoverflow
									dangerouslySetInnerHTML={{ __html: (noLocale ? label : Tyan.t(label, 'label')) || '' }}
								/>
							</Panel>
						</Container>
					}
					{
						buttons && <Panel margin='0 8 0 8' padding='0 0 0 5' docked='right'>
							{buttons.map((o1, i) => {
								const o = reconfigButton(o1)
								const { icon, cdt, _button: text } = o
								const { props: { tooltip, ui, contextmenu, ...btnProps } } = getMixedProps('_button', [toolDefault, o])
								contextmenu && (btnProps.handler = btnProps.handler || ((owner, tool, e) => handleCommonContextMenu(contextmenu, e)))
								return cdt && !cdt() ? null : <Tool key={i} tooltip={tooltip || text}
									{...(icon ? { iconCls: `x-fa fa-${icon}` } : {})} ui={`size16 ${ui || ''}`}
									{...btnProps} padding='0 5 0 0' />
							})}
						</Panel> || null
					}
				</Container>
				< Container userCls='t-form-border-inner' style={borderStyle}
					margin={label || buttons ? '15 0 0 0' : null}
					padding={padding || (label || buttons ? '15 0 10 0' : null)}
					layout={{ type: 'hbox', pack: 'start', wrap: true, ...layout }}
				>
					{items && items.map(({ list, ...item }, index) => renderField({
						field: { ...item, /* index,  */_fieldsetName, ...(forceDisabled ? { disabled: true } : {}), list: genNewList(list, borderList) },
						defaultStyle: { ...defaultStyle, ...rest, ..._default, forceDisabled/* maxWidth: 'calc(100% - 40px)' */ }, initValues, changedValues,
						index, data: that
					})) || null}
				</Container>
			</>
			: null
		}
	</Container >
}

const renderBorder = config => {
	const { key } = config.field || {}
	return <Border key={key} {...config} />
}

export default renderBorder